<form #form="ngForm">
    <!--        Company Name-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>Company Name</mat-label>
            <input
                matInput
                type="text"
                required
                #companyName="ngModel"
                [(ngModel)]="employer.companyName"
                name="companyName"
            />
            <mat-error *ngIf="companyName.invalid">{{ companyName.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <!--        Billing Email-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>Billing Email</mat-label>
            <input
                matInput
                type="email"
                required
                #billingEmail="ngModel"
                [(ngModel)]="employer.billingEmail"
                name="billingEmail"
            />
            <mat-error *ngIf="billingEmail.invalid">{{ billingEmail.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <!--        Primary Contact-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>Primary Contact Name</mat-label>
            <input matInput type="text" #contactName="ngModel" [(ngModel)]="employer.contactName" name="contactName" />
            <mat-error *ngIf="contactName.invalid">{{ contactName.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <!--        Primary Contact Phone-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>Primary Contact Phone</mat-label>
            <input
                matInput
                type="text"
                #contactPhone="ngModel"
                [(ngModel)]="employer.contactPhone"
                name="contactPhone"
                required
            />
            <mat-error *ngIf="contactPhone.invalid">{{ contactPhone.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <!--        Street Address-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>Street Address</mat-label>
            <input matInput type="text" #address1="ngModel" [(ngModel)]="employer.address1" name="address1" />
            <mat-error *ngIf="address1.invalid">{{ address1.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <!--        City-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>City</mat-label>
            <input matInput type="text" #city="ngModel" [(ngModel)]="employer.city" name="city" />
            <mat-error *ngIf="city.invalid">{{ city.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <!--        Province-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>Province</mat-label>
            <ui-state-autocomplete
                placeholder="Province"
                name="province"
                #province="ngModel"
                country="Canada"
                [(ngModel)]="employer.province"
            ></ui-state-autocomplete>
            <mat-error *ngIf="province.invalid">{{ province.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <!--        Postal Code-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>Postal Code</mat-label>
            <input matInput type="text" #postalCode="ngModel" [(ngModel)]="employer.postalCode" name="postalCode" />
            <mat-error *ngIf="postalCode.invalid">{{ postalCode.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <!--        Industry-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label appRemoveAriaOwns>Industry</mat-label>
            <mat-select #industry="ngModel" placeholder="Industry" name="industry" [(ngModel)]="employer.industry">
                <mat-option *ngFor="let industry of industries" [value]="industry.value">{{
                    industry.label
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!--        Number Of Employees-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label appRemoveAriaOwns>Number Of Employees</mat-label>
            <mat-select
                #numberOfEmployees="ngModel"
                placeholder="Number of Employees"
                name="numberOfEmployees"
                [(ngModel)]="employer.numberOfEmployees"
            >
                <mat-option *ngFor="let numberOfEmployees of employeesCount" [value]="numberOfEmployees.value">{{
                    numberOfEmployees.label
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!--        Company Website-->
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>Company Website</mat-label>
            <input matInput type="text" #website="ngModel" [(ngModel)]="employer.website" name="website" />
            <mat-error *ngIf="website.invalid">{{ website.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</form>
